<template>
  <div class="bg">
    <!-- 操作栏 -->
    <div class="top_search_part">
      <div class="search_box">
        <div class="goBackBox" @click="$router.go(-1)">
          <img class="goBackIcon" src="@/assets/backIcon.svg" />
          <span class="goBackTitle">{{ $t('message.backText') }}</span>
        </div>
        <p
          class="operationText marginLeft"
        >{{ $t('message.tempeoraryNameTitle') }}：{{ formalInfo.USHOWNAME }}</p>
        <p
          class="operationText marginLeft"
        >{{ $t('message.attendanceNumTitle') }}：{{ formalInfo.GD4 }}</p>
        <p
          class="operationText marginLeft"
        >{{ $t('message.attendanceHoursTitle') }}：{{ formalInfo.GD5 }}</p>
      </div>
      <div class="search_box">
        <div class="search_item">
          <el-date-picker
            v-model="attendanceTime"
            type="datetimerange"
            range-separator=" - "
            :start-placeholder="$t('message.orderTimeStartHolder')"
            :end-placeholder="$t('message.orderTimeEndHolder')"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </div>
        <div
          class="search_btn"
          @click="dialogFormVisible = true"
        >{{ $t('message.createClockInfo') }}</div>
        <div
          class="search_btn"
          @click="dialogFormVisible1 = true"
        >{{ $t('message.createClockDutyInfo') }}</div>

        <div class="search_btn" @click="searchFormalName">{{ $t('message.searchBtnText') }}</div>
        <div
          class="add_btn"
          style="margin-left: 10px;"
          @click="exportSingleFormal"
        >{{ $t('message.exportText') }}</div>
      </div>
    </div>
    <!-- 操作栏 -->
    <!-- 列表 -->
    <div class="content">
      <div class="tableBox">
        <el-table
          id="clockInList"
          :data="clockInList"
          style="width: 100%"
          stripe
          size="small"
          header-cell-class-name="tableHeader"
          cell-class-name="tableBodyer"
          height="100%"
          v-loading="loading"
        >
          <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="85"></el-table-column>
          <el-table-column :label="$t('message.clockInAddTitle')" prop="address" min-width="200"></el-table-column>
          <el-table-column :label="$t('message.punchInTimeTitle')" min-width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.SIGN1TIME }}</span>
              <div class="operate_btn_box" v-if="isAdmin">
                <el-button
                  class="operation_btn updateBtn"
                  type="text"
                  size="small"
                  @click.native.prevent="setPunchin(scope.row)"
                ></el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.punchOutTimeTitle')" min-width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.SIGN2TIME }}</span>
              <div class="operate_btn_box" v-if="isAdmin">
                <el-button
                  class="operation_btn updateBtn"
                  type="text"
                  size="small"
                  @click.native.prevent="setPunchout(scope.row)"
                ></el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.manHourTitle')" prop="YXSC" min-width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.QWRW">{{ scope.row.YXSC }}({{scope.row.QWRW}})</span>
              <span v-else>{{ scope.row.YXSC }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('message.customTableTitle5')" width="200" fixed="right">
            <template slot-scope="scope">
              <div class="operate_btn_box">
                <el-button
                  class="operation_btn delBtn"
                  type="text"
                  size="small"
                  @click.native.prevent="delSignature(scope.row)"
                ></el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="page_no"
        :page-sizes="pageSizes"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next"
        :total="totalSize"
        class="tablePage"
      ></el-pagination>
    </div>
    <!-- 列表 -->

    <!-- 创建打卡弹出 -->
    <el-dialog
      :title="$t('message.createClockInfo')"
      :visible.sync="dialogFormVisible"
      destroy-on-close
      :close-on-click-modal="false"
      width="30%"
    >
      <div class="dialog_box">
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{ $t('message.clockPlaceInfoTitle') }}</span>
            <el-select v-model="clockPlace" placeholder="请选择" ref="newValue">
              <el-option
                v-for="item in clockAreaInfo"
                :key="item.name"
                :label="item.name"
                ref="newValue"
                :value="item.position"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{ $t('message.clockTimeInfoTitle') }}</span>
            <el-date-picker
              v-model="clockTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              default-time="12:00:00"
              placeholder="请选择日期时间"
            ></el-date-picker>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addNewclockAreaInfo">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 创建打卡弹出 -->

    <!-- 创建勤务日外 -->
    <el-dialog
      :title="$t('message.createClockDutyInfo')"
      :visible.sync="dialogFormVisible1"
      destroy-on-close
      :close-on-click-modal="false"
      width="30%"
    >
      <div class="dialog_box">
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{ $t('message.clockPlaceInfoTitle') }}</span>
            <el-select v-model="clockPlace" placeholder="请选择" ref="newValue">
              <el-option
                v-for="item in clockAreaInfo"
                :key="item.name"
                :label="item.name"
                ref="newValue"
                :value="item.position"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{ $t('message.createClockDutyInfo') }}</span>
            <el-select
              @change="changeClockDutyTime"
              v-model="clockDutyDay"
              placeholder="请选择"
              ref="ClockDuty"
            >
              <el-option
                v-for="item in clockDutyDays"
                :key="item.name"
                :label="item.name"
                ref="ClockDuty"
                :value="item.time"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="dialog_row clock_duty">
          <div class="dialog_item">
            <span class="dialog_item_title">{{ $t('message.clockTimeInfoTitle') }}</span>
            <el-date-picker
              v-model="clockDutyDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            ></el-date-picker>
          </div>
          <div class="dialog_item clock_time">
            <el-time-picker
              is-range
              v-model="clockDutyTime"
              value-format="HH:mm:ss"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围"
            ></el-time-picker>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="addNewclockDutyInfo">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 创建勤务日外 -->

    <el-dialog
      :visible.sync="showDialog"
      :title="dialogTitle"
      width="30%"
      :close-on-click-modal="false"
      center
    >
      <div>
        <el-date-picker
          v-model="punchOutTime"
          type="datetime"
          :placeholder="dialogTitle"
          :editable="false"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmSetPunch">{{ $t('message.confirmText') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  setWorkQwrw,
  delWorkSign,
  getformalClock,
  setFormalPunchIn,
  setFormalPunchOut,
  HTTPS,
  exportSingleFormal,
  setDeliveryClock,
} from '@/api/getData.js'

export default {
  name: 'formalWorkersClockStatistics',
  data() {
    return {
      formalInfo: null,
      page_no: 1,
      page_size: 10,
      pageSizes: [10, 20, 30, 50, 100],
      totalSize: 0,
      loading: false,
      clockInList: [],
      attendanceTime: null,
      isAdmin: false,
      showDialog: false,
      dialogTitle: '',
      punchOutObj: null,
      punchOutTime: '',
      exportJson: {},
      clockPlace: '',
      clockTime: '',
      clockDutyDate: '',
      clockDutyTime: '',
      dialogFormVisible: false,
      dialogFormVisible1: false,
      clockAreaInfo: [
        { name: '大阪営業所', position: [135.51739, 34.697775] },
        { name: 'りんくう営業所', position: [135.3056702861927,34.41508640578548] },
        {
          name: '東京営業所',
          position: [139.79578160466585, 35.61742737611041],
        }, //〒135-0063 東京都江東区有明４丁目８−６　3-2
        { name: '関空営業所', position: [135.22871681821, 34.425628463818] },
        { name: '泉佐野営業所', position: [135.354768, 34.375455] }, //大阪府泉佐野市日根野5569-1
        { name: '市川営業所', position: [139.95651688299, 35.678137454673] },
        { name: '大田営業所', position: [139.753682, 35.586295] }, //東京都大田区東海1-3-6
        {
          name: '藤井寺営業所',
          position: [135.58462696676932, 34.586909232516845],
        },
        { name: '成田営業所', position: [140.402883, 35.740556] }, //千葉県山武郡山町岩山字根木田125番地3-5F
      ],
      clockDutyDays: [
        // 【有休】默认上班时间为9点-18点
        // 【半休】默认上班时间为9点-13点
        // 【研修】默认上班时间为9点-18点
        // 【その他】默认上班时间为9点-18点
        // { name: '有休',time: [new Date(2016, 9, 10, 9, 0), new Date(2016, 9, 10, 18, 0)]},
        { name: '有休', time: ['09:00:00', '18:00:00'] },
        { name: '半休', time: ['09:00:00', '13:00:00'] },
        { name: '研修', time: ['09:00:00', '18:00:00'] },
        { name: 'その他', time: ['09:00:00', '18:00:00'] },
      ],
      clockDutyDay: '',
    }
  },
  created() {
    this.isAdmin = this.$store.state.JHSS.personalUserid.includes('admin')
    let query = this.$route.query
    this.formalInfo = JSON.parse(query.formalInfo)
    this.formalInfo.phone = this.formalInfo.TELPHONE.replace(
      /(\d{3})(\d{4})(\d{4})/g,
      '$1****$3'
    )
    // console.log(JSON.parse(query.attendanceTime))
    this.attendanceTime = JSON.parse(query.attendanceTime)
    this.searchFormalName()
  },
  methods: {
    //显示勤务日外的时间
    changeClockDutyTime(e) {
      this.clockDutyTime = e
    },

    delSignature(obj) {
      // console.log(obj)

      // if(obj.SIGN2TIME){
      // 	 this.$message.error(this.$t('message.delClockmessage'))
      // 	 return
      // }
      this.$confirm(
        this.$t('message.delClockInfo'),
        this.$t('message.promptTitle'),
        {
          closeOnClickModal: false,
          confirmButtonText: this.$t('message.confirmText'),
          cancelButtonText: this.$t('message.cancleText'),
        }
      )
        .then(() => {
          this.del(obj.ID)
        })
        .catch(() => {
          this.$message(this.$t('message.canclePrompt'))
        })
    },
    async del(id) {
      let param = { ID: id, USERID: this.$store.state.JHSS.personalUserid }
      let res = await delWorkSign(param)
      if (res.status !== 200) {
        this.$message.error('network error：' + res.status)
        return
      }
      if (res.data.result !== '1') {
        this.$message.error(res.data.message)
      } else {
        // this.page_no = 1
        // this.getSignatureList()
        this.searchFun()
      }
    },
    // 查询正式员工打卡记录
    async getClockInList(param) {
      this.loading = true
      param = param || {}
      param.USERID = this.formalInfo.USERID
      param.PAGE = this.page_no
      param.TYPE = this.page_size
      // let param = { USERID: this.formalInfo.USERID, PAGE: this.page_no, TYPE: this.page_size }
      let res = await getformalClock(param)
      this.loading = false
      if (res.status !== 200) {
        this.$message.error('network error：' + res.status)
      } else {
        // console.log(res.data.dt)
        this.totalSize = res.data.num
        let index = 0
        this.clockInList = res.data.dt.map((item) => {
          item.index = ++index
          item.address = item.SINGOROPEN === 'S' ? item.SIGN1C : item.OPENBOXC
          item.SIGN1TIME = !item.SIGN1TIME
            ? ''
            : item.SIGN1TIME.replace(/T/g, ' ')
          item.SIGN2TIME = !item.SIGN2TIME
            ? ''
            : item.SIGN2TIME.replace(/T/g, ' ')
          return item
        })
        this.exportJson = param
      }
    },
    searchFormalName() {
      this.searchFun()
    },
    sizeChange(val) {
      this.page_size = val
      this.searchFun()
    },
    currentChange(val) {
      this.searchFun(val)
    },
    searchFun(val) {
      this.page_no = val || 1
      let param = {}
      if (this.attendanceTime) {
        param.UADDTIME = this.attendanceTime[0]
        param.DADDTIME = this.attendanceTime[1]
      }
      this.getClockInList(param)
    },
    // 设置上班时间
    setPunchin(obj) {
      this.punchOutObj = obj
      this.punchOutTime = obj.SIGN1TIME.split(' ')[1]
      this.dialogTitle = this.$t('message.punchInTimeTitle')
      this.showDialog = true
    },
    // 设置下班时间
    setPunchout(obj) {
      this.punchOutObj = obj
      this.punchOutTime = ''
      this.dialogTitle = this.$t('message.punchOutTimeTitle')
      this.showDialog = true
    },
    async confirmSetPunch() {
      if (
        !this.punchOutTime &&
        this.dialogTitle === this.$t('message.punchInTimeTitle')
      ) {
        this.$message(this.$t('message.punchInTimeTitle'))
      } else if (
        !this.punchOutTime &&
        this.dialogTitle === this.$t('message.punchOutTimeTitle')
      ) {
        this.$message(this.$t('message.punchOutTimeTitle'))
      } else if (this.dialogTitle === this.$t('message.punchInTimeTitle')) {
        let param = this.punchOutObj
        //param.SIGN1TIME = this.punchOutObj.YMD + ' ' + this.punchOutTime;
        param.SIGN1TIME = this.punchOutTime
        param.GUDING2 = this.$store.state.JHSS.personalUserid
        // console.log(param)
        //let res = await setFormalPunchIn(param)
        let res = await setFormalPunchOut(param)
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data)
        if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          this.showDialog = false
          this.getClockInList()
        }
      } else if (this.dialogTitle === this.$t('message.punchOutTimeTitle')) {
        let param = this.punchOutObj
        //param.SIGN2TIME = this.punchOutObj.YMD + ' ' + this.punchOutTime;
        param.SIGN2TIME = this.punchOutTime
        param.GUDING1 = this.$store.state.JHSS.personalUserid
        // console.log(param)
        let res = await setFormalPunchOut(param)
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data)
        if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          this.showDialog = false
          this.getClockInList()
        }
      }
    },
    // 导出一个正式员工工资表
    async exportSingleFormal() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      let param = this.exportJson
      let res = await exportSingleFormal(param)
      loading.close()
      if (res.status !== 200) {
        this.$message.error('network error：' + res.status)
      } else {
        // console.log(res.data)
        let str = HTTPS + '/xlsx/' + res.data
        window.open(str)
      }
    },

    //创建勤务日外打卡
    async addNewclockDutyInfo() {
      if (!this.clockPlace) {
        this.$message.error(
          this.$t('message.exportDatePlaceholder') +
            this.$t('message.clockPlaceInfoTitle')
        )
      } else if (!this.clockDutyDate) {
        this.$message.error(
          this.$t('message.exportDatePlaceholder') +
            this.$t('message.clockTimeInfoTitle')
        )
      } else if (!this.clockDutyTime) {
        this.$message.error(
          this.$t('message.exportDatePlaceholder') +
            this.$t('message.clockTimeInfoTitle')
        )
      } else if (!this.clockDutyDay) {
        this.$message.error(
          this.$t('message.exportDatePlaceholder') +
            this.$t('message.createClockDutyInfo')
        )
      } else {
        console.log(this.clockDutyTime)
        // console.log(this.$refs.ClockDuty);

        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        let param = {
          GUDING1: this.$store.state.JHSS.personalUserid,
          GUDING2: this.$store.state.JHSS.personalUserid,
          SIGNMANUSERID: this.formalInfo.USERID,
          SIGN1TIME: this.clockDutyDate + ' ' + this.clockDutyTime[0],
          SIGN2TIME: this.clockDutyDate + ' ' + this.clockDutyTime[1],
          YMD: this.clockDutyDate,
          SIGN1A: this.$refs.newValue.value[0],
          SIGN1B: this.$refs.newValue.value[1],
          SIGN1C: this.$refs.newValue.$children[0].nativeInputValue,
          QWRW: this.$refs.ClockDuty.$children[0].nativeInputValue,
        }
        console.log(param)
        let res = await setWorkQwrw(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data)
        if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          this.dialogFormVisible1 = false
          this.getClockInList()
        }
      }
    },

    //添加配送员打卡信息
    async addNewclockAreaInfo() {
      // console.log(this.$refs.newValue.value);
      // console.log(/\d{4}-\d{1,2}-\d{1,2}/g.exec(this.clockTime)[0]);
      // console.log(this.formalInfo.USERID);
      // console.log(this.$refs.newValue.$children[0].nativeInputValue);
      if (!this.clockPlace) {
        this.$message.error(
          this.$t('message.exportDatePlaceholder') +
            this.$t('message.clockPlaceInfoTitle')
        )
      } else if (!this.clockTime) {
        this.$message.error(
          this.$t('message.exportDatePlaceholder') +
            this.$t('message.clockTimeInfoTitle')
        )
      } else {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        let param = {
          GUDING1: this.$store.state.JHSS.personalUserid,
          SIGNMANUSERID: this.formalInfo.USERID,
          SIGN1TIME: this.clockTime,
          YMD: /\d{4}-\d{1,2}-\d{1,2}/g.exec(this.clockTime)[0],
          SIGN1A: this.$refs.newValue.value[0],
          SIGN1B: this.$refs.newValue.value[1],
          SIGN1C: this.$refs.newValue.$children[0].nativeInputValue,
        }
        let res = await setDeliveryClock(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data)
        if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          this.dialogFormVisible = false
          this.getClockInList()
        }
      }
    },
  },
}
</script>

<style scoped>
.operationText {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  color: #333333;
  line-height: 27px;
}
.marginLeft {
  margin-left: 40px;
}

.clock_duty {
  display: flex;
  flex-direction: column;
}
.clock_duty .clock_time {
  margin-left: 140px;
}
</style>
